import { IconType } from '../components/various/Icon/Icon';

export type SolutionFilterTag = 'Industry' | 'Use-case';

export const SOLUTION_FILTER_OPTIONS: { id: SolutionFilterTag; label: string }[] = [
  { id: 'Industry', label: 'By industry' },
  { id: 'Use-case', label: 'By use-case' },
];

export const SOLUTION_FILTER_DESCRIPTIONS: Record<SolutionFilterTag, string> = {
  Industry:
    'Industry pages are written for a specific kind of studio or team—agencies, production houses, photographers, print, and design.',
  'Use-case':
    'Use-case pages follow a job: production management, client approvals, and creative proofing, regardless of who is on the roster.',
};

export interface SolutionPage {
  title: string;
  description: string;
  navDescription: string;
  href: string;
  icon: IconType;
  tags: SolutionFilterTag[];
  order: number;
}

export const SOLUTION_PAGES: SolutionPage[] = [
  {
    title: 'Advertising & Marketing Agencies',
    description:
      'Streamline campaign production with frame-accurate video review, asset-linked feedback, and no-signup client links.',
    navDescription: 'Solutions for creative agencies',
    href: '/solutions/industry/advertising-marketing-agencies',
    icon: 'building',
    tags: ['Industry'],
    order: 1,
  },
  {
    title: 'Video Production & Animation Studios',
    description:
      'Frame-accurate feedback, version control, and collaboration for video production and animation teams.',
    navDescription: 'Solutions for production teams',
    href: '/solutions/industry/video-production-animation-studios',
    icon: 'addVideo',
    tags: ['Industry'],
    order: 2,
  },
  {
    title: 'In-House Creative & Content Teams',
    description:
      'Centralized brand asset management, stakeholder approvals, and collaboration with external agencies.',
    navDescription: 'Solutions for in-house teams',
    href: '/solutions/industry/in-house-creative-content-teams',
    icon: 'group',
    tags: ['Industry'],
    order: 3,
  },
  {
    title: 'Photography Studios',
    description:
      'Photo proofing with pinned comments on stills and no-signup client links. Not a print-store gallery.',
    navDescription: 'Photo proofing for stills studios',
    href: '/solutions/industry/photography-studios',
    icon: 'panorama',
    tags: ['Industry'],
    order: 4,
  },
  {
    title: 'Print & Packaging',
    description: 'Artwork approval software for labels, cartons, and print PDFs with pinned comments and guest links.',
    navDescription: 'Artwork approval for print teams',
    href: '/solutions/industry/print-and-packaging',
    icon: 'filePdf',
    tags: ['Industry'],
    order: 5,
  },
  {
    title: 'Graphic Design Studios',
    description: 'Graphic design proofing for layouts, stills, and guest client markup—not a studio booking OS.',
    navDescription: 'Proofing for design studios',
    href: '/solutions/industry/graphic-design-studios',
    icon: 'paint',
    tags: ['Industry'],
    order: 6,
  },
  {
    title: 'Creative Production Management',
    description:
      'Manage video work around the files themselves. Every file, version, comment, and approval stays connected.',
    navDescription: 'End-to-end production workflows',
    href: '/solutions/use-case/creative-production-management',
    icon: 'board',
    tags: ['Use-case'],
    order: 7,
  },
  {
    title: 'Client Approvals',
    description: 'Approvals tied to exact file versions. Track who signed off and keep an audit trail.',
    navDescription: 'Version-specific client approvals',
    href: '/solutions/use-case/client-approvals',
    icon: 'checkCircle',
    tags: ['Use-case'],
    order: 8,
  },
  {
    title: 'Creative Proofing',
    description: 'Comment on files, compare versions, and turn feedback into trackable work with a review history.',
    navDescription: 'Turn feedback into trackable work',
    href: '/solutions/use-case/creative-proofing',
    icon: 'compare',
    tags: ['Use-case'],
    order: 9,
  },
];

export const SOLUTION_INDUSTRY_NAV_ITEMS = SOLUTION_PAGES.filter((page) => page.tags.includes('Industry')).map(
  (page) => ({
    label: page.title,
    href: page.href,
    description: page.navDescription,
  }),
);

export const SOLUTION_USE_CASE_NAV_ITEMS = SOLUTION_PAGES.filter((page) => page.tags.includes('Use-case')).map(
  (page) => ({
    label: page.title,
    href: page.href,
    description: page.navDescription,
  }),
);
